import { Link } from "react-router-dom";
import { topicList } from "@/mocks/topics";

export default function TopicSection() {
  return (
    <section>
      <div className="flex items-end justify-between mb-4">
        <div>
          <h2 className="flex items-center gap-2 font-heading font-bold text-foreground-950 text-lg md:text-xl">
            <i className="ri-bookmark-3-line text-accent-500" />
            热门主题专题
          </h2>
          <p className="mt-1 text-xs md:text-sm text-foreground-600">按主题聚合，一次看懂同类型的精彩内容</p>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
        {topicList.map((topic) => (
          <Link
            key={topic.id}
            to="/news"
            className="group relative rounded-lg overflow-hidden bg-foreground-950 h-44 cursor-pointer"
          >
            <img
              src={topic.cover}
              alt={topic.title}
              title={topic.title}
              className="w-full h-full object-cover object-top opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/40 to-transparent" />
            <div className="absolute inset-0 flex flex-col justify-end p-4">
              <span className="self-start px-2 py-0.5 rounded bg-accent-500 text-background-50 text-[11px] font-medium">
                {topic.tag}
              </span>
              <h3 className="mt-2 font-heading font-bold text-background-50 text-base">{topic.title}</h3>
              <p className="mt-1 text-xs text-background-200 line-clamp-2 leading-relaxed">{topic.intro}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}